export const DROPDOWN_SELECT_ALL = 'Все';
export const NOT_GEOCODED = 'Не геокодированные';
export const NOT_GEOZONE = 'Нет привязки к геозоне';
export const GEOZONED = 'Все зоны'

export enum GeozoneSelectEnum {
    ALL = 'Все',
    NOT_GEOCODED = 'Не геокодированные',
    NOT_GEOZONE = 'Нет привязки к геозоне',
    GEOZONED = 'Все зоны'
}

export enum DeliveryClassEnum {
    DELIVERY = 'DELIVERY',
    INTAKE = 'INTAKE',
}

export enum DeliveryTypeEnum {
    DELIVERY = 'DELIVERY',
    NPO_DELIVERY = 'NPO_DELIVERY',
    INTAKE = 'INTAKE',
    INTAKE_INDIVIDUAL = 'INTAKE_INDIVIDUAL',
    PENSION = 'PENSION',
    DELIVERY_COD = 'DELIVERY_COD'
}

const DeliveryTypeDeliveryClass: { [key in DeliveryTypeEnum]: DeliveryClassEnum } = {
    [DeliveryTypeEnum.DELIVERY]: DeliveryClassEnum.DELIVERY,
    [DeliveryTypeEnum.NPO_DELIVERY]: DeliveryClassEnum.DELIVERY,
    [DeliveryTypeEnum.INTAKE]: DeliveryClassEnum.INTAKE,
    [DeliveryTypeEnum.INTAKE_INDIVIDUAL]: DeliveryClassEnum.INTAKE,
    [DeliveryTypeEnum.PENSION]: DeliveryClassEnum.DELIVERY,
    [DeliveryTypeEnum.DELIVERY_COD]: DeliveryClassEnum.DELIVERY,
}

export const isDeliveryType = (deliveryType: string | undefined) => {
    if (!deliveryType) {
        return false;
    }
    return DeliveryTypeDeliveryClass[deliveryType as unknown as DeliveryTypeEnum] === DeliveryClassEnum.DELIVERY;
}